import { QRCodeCanvas } from 'qrcode.react';
import { useState } from 'react';

import { CopyValue } from 'components/CopyValue';
import { TotemCheckbox } from 'components/TotemCheckbox';
import { TotemInput } from 'components/TotemInput';
import { TotemLabel } from 'components/TotemLabel';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { useGetTestSenseiGateTokenLazyQuery } from 'data/__generated__';

import styled from 'styled-components';

export const SenseiSettings = (): JSX.Element => {
    const [token, setToken] = useState<string | null>(null);
    const [isStaff, setIsStaff] = useState<boolean>(false);
    const [senseiUserId, setSenseiUserId] = useState<string>('');
    const [getGateToken] = useGetTestSenseiGateTokenLazyQuery();

    const handleGetToken = async (): Promise<void> => {
        const response = await getGateToken({ variables: { isStaff, senseiUserId } });

        if (response?.data?.testSenseiGateToken) {
            setToken(response.data.testSenseiGateToken);
        }
    };

    return (
        <>
            <SectionTitle>Compte</SectionTitle>
            <TotemInput
                label="Id utilisateur pour sensei"
                value={senseiUserId}
                placeholder="UserId"
                onChange={(value) => setSenseiUserId(value)}
            />
            <TotemCheckbox checked={isStaff} onChange={() => setIsStaff(!isStaff)} label="QR code pour staff ?" />
            <TotemPrimaryButton $isSecondaryStyle onClick={handleGetToken}>
                Get gate token
            </TotemPrimaryButton>
            {token ? (
                <>
                    <CopyValue label="Token" value={token} /> <TotemLabel>QR Code</TotemLabel>
                    <QRCodeContainer>
                        <QRCodeCanvas value={token} size={200} />
                    </QRCodeContainer>
                </>
            ) : null}
        </>
    );
};

const SectionTitle = styled.h3`
    color: ${({ theme }) => theme.textColor};
    margin-top: 20px;
    margin-bottom: 5px;
    font-size: 16px;
`;

const QRCodeContainer = styled.div`
    padding: 10px;
    background-color: white;
    height: 220px;
    width: 220px;
`;
